<script setup>
import { ref, onMounted } from 'vue'
import '../assets/styles/sanitize.css'
import '../assets/styles/app.css'
import HeaderForecastHistory from './HeaderForecastHistory.vue'
import HeaderBottom from './HeaderBottom.vue'
import HeaderOverlay from './HeaderOverlay.vue'
import HeaderSearchArea from './HeaderSearchArea.vue'
import { useCommon } from '../composable/useCommon.js'
import { vOnClickOutside } from '@vueuse/components'
const { isWebView } = useCommon()
const props = defineProps({
  devDomains: { type: Object, default: () => {} },
  isWebViewProp: { type: Boolean, default: false },
})
const isWebViewFlag = ref(props.isWebViewProp)
const isMenu = ref(false)
const isOverlayMenuShow = ref(false)
const isOverlaySearchShow = ref(false)
const closeModal = () => {
  isOverlayMenuShow.value = false
  isOverlaySearchShow.value = false
}
const closeMenu = () => {
  isMenu.value = false
}
onMounted(() => {
  isWebViewFlag.value = isWebView()
})
</script>

<template>
  <header
    v-if="!isWebViewFlag"
    class="globalHeader is-fixed"
    :class="{ 'data-menu' : isMenu }"
  >
    <section class="headerTop">
      <div class="inner wrap">
        <div class="wniLogo">
          <a href="https://weathernews.jp/?fm=header">
            <img
              src="https://gvs.weathernews.jp/onebox/img/header/logo_wni.svg"
              width="184"
              height="40"
              alt="ウェザーニュース"
              class="pc"
            >
            <img
              src="https://gvs.weathernews.jp/onebox/img/header/logo_wni_sp.svg"
              width="36"
              height="36"
              alt="ウェザーニュース"
              class="sp"
            >
          </a>
        </div>
        <HeaderForecastHistory />
        <HeaderSearchArea
          @click-search="isOverlaySearchShow = true"
        />
      </div>
      <div
        ref="button"
        class="button sp"
      >
        <div
          class="circle"
          @click="isMenu = true"
        />
      </div>
    </section>
    <HeaderOverlay
      v-if="isOverlayMenuShow || isOverlaySearchShow"
      :is-overlay-menu-show="isOverlayMenuShow"
      :is-overlay-search-show="isOverlaySearchShow"
      :dev-domains="devDomains"
      @close="closeModal"
    />
    <HeaderBottom
      v-model="isMenu"
      v-on-click-outside="closeMenu"
      :dev-domains="devDomains"
      @overlay-menu="isOverlayMenuShow = !isOverlayMenuShow"
    />
  </header>
</template>

<style lang="scss" scoped>
.globalHeader {
  &.is-fixed {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    z-index: 100;
    .headerTop {
      position: relative;
      z-index: 10;
      background-color: #fff;
      box-shadow: 0 2px 4px 0 rgba(#000, .15);
      transition: .3s ease-in-out .3s;
      .button {
        position: absolute;
        top: 100%;
        right: 0;
        padding: 10px 2px 2px;
        width: 32px;
        height: 40px;
        background-color: #3569c0;;
        border-bottom-left-radius: 16px;
        border-bottom-right-radius: 16px;
        transition: .3s ease-in-out .3s;
        .circle {
          transform: rotate(90deg);
          width: 28px;
          height: 28px;
          background-color: #fff;
          border-radius: 50%;
          background-image: url('https://gvs.weathernews.jp/onebox/img/common/icon_arrow.svg');
          background-position: center;
          background-repeat: no-repeat;
          background-size: contain;
        }
      }
    }
    &.data-menu {
      .button {
        pointer-events: none;
        opacity: 0;
      }
    }
  }
  .wrap {
    width: 100%;
    max-width: 1100px;
    margin-left: auto;
    margin-right: auto;
  }
  .headerTop {
    display: flex;
    justify-content: space-between;
    padding: 0 10px;
  }
  .inner {
    display: flex;
    gap: 10px;
  }
  .wniLogo {
    display: flex;
    align-items: center;
    position: relative;
    padding-top: 4px;
    padding-bottom: 4px;
    &::before {
      position: absolute;
      top: 0;
      right: -15px;
      width: 5px;
      height: 100%;
      background: linear-gradient(90deg, rgba(#000, .25) 0%, rgba(#000, 0) 100%);
      z-index: 2;
      content: '';
    }
  }
  @media screen and (min-width: 830px) {
    .headerTop {
      padding: 0 15px;
    }
    .wniLogo {
      a {
        transition: opacity .2s ease-in-out;
        &:hover {
          opacity: .6;
        }
      }
      &::before {
        display: none;
      }
    }
  }
}
</style>
